import React, { useState, useEffect, useCallback } from "react";
import { Table, Alert, Spin, Modal, Button, ConfigProvider } from "antd";
import ProcessDevice from "./ProcessDevice";
import { getAPI, getPDF } from "../../../config/api/apiConfig";
import moment from "moment";
import { saveAs } from 'file-saver';

import {

  DisconnectOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { setListDevice, setIsDeviceApproved } from "../../../redux/feature/device";
import {
  FilePdfOutlined,
  FileWordOutlined,
  FileExcelOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import ApproveDevicereport from "./ApproveDeviceReport";



const getFileIcon = (extension) => {
  switch (extension) {
    case ".pdf":
      return <FilePdfOutlined />;
    case ".docx":
      return <FileWordOutlined />;
    case ".xlsx":
      return <FileExcelOutlined />;
    default:
      return null;
  }
};


const handleDownload = async (id, index, fileName) => {
  try {
    const response = await getPDF(`/download-report-file/${id}?index=${index}`, {
      responseType: "blob",
    });

    const blob = new Blob([response.data]);
    const fileNameWithoutUnderscore = fileName.replace(/_+\./, ".");
    saveAs(blob, fileNameWithoutUnderscore);
  } catch (error) {
    console.error(error);
  }
};


const { confirm } = Modal;

const ListTreatedReports = () => {
  const [reportData, setReportData] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [open, setOpen] = useState(false);
  const [columnData, setColumnData] = useState([])

  const role = useSelector((state) => state.authenticate.role);

  let status;
  if (role === "Nibss_Super_Cert01") {
    status = "approved";
  } else if (role === "Nibss_Admin_Ticket") {
    status = "treated";
  } else {
    status = "pending";
  }

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 24,
      }}
      spin
    />
  );



  // const showPromiseConfirm = () => {
  //   return confirm({
  //     title: "Do you want to disable these Device?",
  //     icon: <ExclamationCircleFilled />,
  //     content:
  //       "This device will be disabled and will not be able to be used again",
  //     onOk() {
  //       // handleDownload()
  //     },
  //     onCancel() {},
  //   });
  // };

  const showPromiseConfirm = () => {
    return confirm({
      title: "Do you want to disable these Device?",
      icon: <ExclamationCircleFilled />,
      content:
        "This device will be disabled and will not be able to be used again",
      okText: "Disable",
      cancelText: null,
      onOk() {
        // handleDownload()
      },
    });
  };
  

  const columns = [
    {
      title: "View Technical Report by Admin",
      dataIndex: "reportFile",
      key: "reportFile",
      width: "20%",
      responsive: ["md"],
      className: "break-spaces",
    },
    {
      title: "Admin Remark",
      dataIndex: "adminRemark",
      key: "adminRemark",
      className: "remark-header",
      responsive: ["md"],
      width: "25%",
    },
    {
      title: "Treated By",
      dataIndex: "treatedBy",
      key: "treatedBy",
      width: "10%",
    },
    {
      title: "Device",
      dataIndex: "device",
      key: "device",
      width: "10%",
    },
    {
      title: "Orgainisation",
      dataIndex: "organisationName",
      key: "organisationName",
      className: "custom-header",
      width: "15%",
      style: { color: "red" },
    },
    {
      title: "Treated Date",
      dataIndex: "treatedDate",
      key: "treatedDate",
      width: "5%",
    },

    {
      title: "",
      dataIndex: "x",
      key: "x",
      width: "5%",
      render: (item) => (
        <a onClick={()=> {
          console.log(item)
          showPromiseConfirm()
        } }>
          <DisconnectOutlined />
        </a>
      ),
    },
  ];


  const dispatch = useDispatch();
  const isDeviceApproved = useSelector((state) => state.device.isDeviceApproved);


  const getReport = async () => {
    const reportes = await getAPI(`/list-device-report`);
    const { data } = reportes.data;
    console.log("DAta", data)
    setReportData(data);
  };


  
  
  // const columnData = [];
  
  useEffect(() => {
    const processedData = reportData.map((report, index) => {
      const reportFile = report.deviceReportPaths.map((filepath, index) => {
        const filename = filepath
          .split("/")
          .pop()
          .replace(/-/g, " ")
          .replace(/\d+/g, "");
        const extension = filename.split(".").pop();
        const nameWithoutExtension = filename.substring(
          0,
          filename.lastIndexOf(".")
        );
        const spacedFilename = `${nameWithoutExtension.toUpperCase()}.${extension} `;
        const _extension = `.${spacedFilename.split(".").pop()}`;
        const icon = getFileIcon(_extension.trim());
        const fileNameWithoutSpaces = spacedFilename.replace(/\s+/g, "");
        return (
          <a
            key={index}
            onClick={() =>
              handleDownload(report.id, index, fileNameWithoutSpaces)
            }
          >
            {icon && <span>{icon}</span>}
            {"  "}
            {nameWithoutExtension.toUpperCase()}
          </a>
        );
      });

      return {
        key: report.id,
        adminRemark: report.adminRemarks,
        reportFile: reportFile,
        treatedBy: report.UserDevice?.User?.organisationName || "not shown",
        device: report.UserDevice.deviceName || "not shown",
        treatedDate: moment(report.createdAt).format("MMMM Do YYYY, h:mm:ss a"),
        organisationName:
          report.UserDevice?.User?.organisationName || "not shown",
        description: (
          <ApproveDevicereport
          getReportref={getReport}
            reportId={report.id}
            deviceName={report?.UserDevice.deviceName}
            organisationName={report?.UserDevice?.User?.organisationName}
            deviceId={report.UserDevice.id}
            // scannerName={report?.UserDevice?.biometricScanner}
            deviceModel={report?.UserDevice?.deviceModel}
          />
        ),
      };
    });

    setColumnData(processedData);
  }, [reportData]);

  

  const handleExpand = (expanded, record) => {
    if (expanded) {
      setExpandedRowKeys([record.key]);
    } else {
      setExpandedRowKeys([]);
    }
  };

  useEffect(() => {
    getReport();
    dispatch(setListDevice());
  }, []);

  return reportData.length !== 0 ? (
    <>
    
      <Table
        columns={columns}
        scroll={{ x: true, y: 700 }}
        expandable={{
          expandedRowRender: (record) => (
            <p
              style={{
                margin: 0,
                wordWrap: "break-word",
              }}
            >
              {record.description}
            </p>
          ),
          rowExpandable: (record) => record.name !== "Not Expandable",
          expandedRowKeys,
          onExpand: handleExpand,
        }}
        
        dataSource={columnData}
      />
    </>
  ) : reportData === undefined ? (
    <Spin
      direction="vertical"
      indicator={antIcon}
      style={{
        width: "100%",
        margin: "30% 0",
        marginBottom: "20px",
        padding: "30px 50px",
        textAlign: "center",
        borderRadius: "4px",
      }}
      
    />
    
  ) : (
    <Alert
      message="No Device "
      description="No pending device for review and approval"
      className="alert"
      showIcon
    />
  );
};

export default ListTreatedReports;
